import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse9 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21V8.75L12 2L3 8.75V21H21Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7.7046 15C8.75275 16.2275 10.223 17 12 17C13.777 17 15.2472 16.2275 16.2954 15", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconHouse9.js.map